import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { InputString } from 'eone-ui/inputs/input-string';
import { useEffect, useState } from 'react';
import './cell_input_with_variable_picker.css';

interface CellInputWithVariablePickerProps {
  Value: string;
  OnChange: (value: string) => void;
  OnPickVariable: () => void;
  Title?: string;
  Placeholder?: string;
  /** False hides the chevron, for a cell with nothing to pick from. Defaults to true. */
  ShowPicker?: boolean;
  /** The chevron's tooltip. Defaults to 'Insert variable'. */
  PickerTitle?: string;
}

export function CellInputWithVariablePicker(props: CellInputWithVariablePickerProps) {
  const [value, setValue] = useState(props.Value ?? '');

  useEffect(() => {
    setValue(props.Value ?? '');
  }, [props.Value]);

  const handleChange = (next: string) => {
    setValue(next);
  };

  const handleBlur = (next: string) => {
    if (next !== props.Value) {
      props.OnChange(next);
    }
  };

  const suffixButtons = [
    {
      Visible: props.ShowPicker ?? true,
      Icon: faChevronDown,
      Title: props.PickerTitle ?? 'Insert variable',
      OnClick: props.OnPickVariable,
    },
  ];

  return (
    <InputString
      Value={value}
      Title={props.Title ?? ''}
      ContainerClass="eone-ui-input-table sce-cell-variable-picker"
      Placeholder={props.Placeholder}
      OnChange={handleChange}
      OnBlur={handleBlur}
      SuffixButtons={suffixButtons}
    />
  );
}
